import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { COMPANY } from '../data/content';

export const Footer = () => {
  return (
    <footer
      className="bg-[#07111C] text-white border-t border-white/5"
      data-testid="footer"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 md:py-24">
        <div className="grid md:grid-cols-12 gap-12 mb-16">
          {/* Brand */}
          <div className="md:col-span-5">
            {/* Brand mark with soft spotlight halo */}
            <div className="relative inline-block mb-8">
              <div
                className="absolute inset-0 -m-6 pointer-events-none"
                style={{
                  background:
                    'radial-gradient(ellipse at center, rgba(245,240,230,0.25) 0%, rgba(245,240,230,0.12) 40%, rgba(245,240,230,0) 75%)',
                  filter: 'blur(10px)',
                }}
                aria-hidden="true"
              />
              <img
                src="/assets/tsalach-logo.png"
                alt="Tsalach Cleaning Services"
                className="relative h-16 lg:h-20 w-auto object-contain"
                data-testid="footer-logo"
                style={{
                  filter:
                    'drop-shadow(0 2px 6px rgba(212,175,55,0.3)) drop-shadow(0 0 14px rgba(245,240,230,0.4))',
                }}
              />
            </div>
            <p className="text-white/65 max-w-sm leading-relaxed">
              {COMPANY.tagline}
            </p>
            <p className="text-xs text-white/70 mt-6 tracking-wider">
              Licensed · Insured · Bonded
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#C9A84C] mb-5">Services</div>
            <ul className="space-y-3 text-sm text-white/60">
              <li><a href="#services" className="hover:text-[#C9A84C] transition-colors">Residential</a></li>
              <li><a href="#services" className="hover:text-[#C9A84C] transition-colors">Commercial</a></li>
              <li><a href="#services" className="hover:text-[#C9A84C] transition-colors">Airbnb</a></li>
              <li><a href="#services" className="hover:text-[#C9A84C] transition-colors">Deep Clean</a></li>
              <li><a href="#services" className="hover:text-[#C9A84C] transition-colors">Move In/Out</a></li>
              <li><a href="#services" className="hover:text-[#C9A84C] transition-colors">Window Cleaning</a></li>
              <li><a href="#services" className="hover:text-[#C9A84C] transition-colors">Carpet Cleaning</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#C9A84C] mb-5">Studio</div>
            <ul className="space-y-3 text-sm text-white/60">
              <li><a href="#work" className="hover:text-[#C9A84C] transition-colors">Our Work</a></li>
              <li><a href="#voices" className="hover:text-[#C9A84C] transition-colors">Voices</a></li>
              <li><a href="#contact" className="hover:text-[#C9A84C] transition-colors">Contact</a></li>
              <li><a href="/admin" className="hover:text-[#C9A84C] transition-colors">Admin</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#C9A84C] mb-5">Get in touch</div>
            <ul className="space-y-4 text-sm text-white/70">
              {COMPANY.phones.map((p) => (
                <li key={p} className="flex items-start gap-3">
                  <Phone className="w-4 h-4 text-[#C9A84C] flex-shrink-0 mt-0.5" strokeWidth={1.75} />
                  <a href={`tel:${p.replace(/\D/g, '')}`} className="hover:text-[#C9A84C] transition-colors">
                    {p}
                  </a>
                </li>
              ))}
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-[#C9A84C] flex-shrink-0 mt-0.5" strokeWidth={1.75} />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-[#C9A84C] transition-colors break-all">
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#C9A84C] flex-shrink-0 mt-0.5" strokeWidth={1.75} />
                <span className="text-white/70">{COMPANY.serviceArea}</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-4 h-4 text-[#C9A84C] flex-shrink-0 mt-0.5" strokeWidth={1.75} />
                <span className="text-white/70">Mon – Sat · 6am – 10pm</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-xs text-white/70">
            © {new Date().getFullYear()} Tsalach Cleaning Services. All rights reserved.
          </p>
          <p className="text-[10px] tracking-[0.4em] uppercase text-[#C9A84C]/60">
            {COMPANY.tagline}
          </p>
        </div>
      </div>
    </footer>
  );
};
